import { useTemplates } from '../api'

export function useSablonlar() {
  return useTemplates().data ?? []
}
